import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEllipsisV,
  faEllipsisH,
  faPlus,
  faChevronRight,
  faTimes,
  faArrowRight,
  faLink,
  faBookOpen,
  faSortAmountDownAlt,
  faEye,
  faCopy,
  faInfinity,
  faArrowUp,
  faArrowDown,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faReceipt,
  faGift,
  faGamepad,
  faUserTie,
  faCreditCard,
  faHome,
  faTable,
  faShareSquare,
  faEnvelope,
  faCode,
  faPaperPlane,
  faShare,
  faCloudDownloadAlt,
  faShareAlt,
  faCheckCircle,
  faSearch,
  faExclamationCircle,
  faArrowAltCircleLeft,
  faUser,
  faCheck,
  faBars,
  faChevronLeft,
  faChevronDown,
  faHistory,
  faTrashAlt,
  faCheckSquare,
  faSquare,
  faPencilAlt,
  faBug,
  faBomb,
  faArrowLeft,
  faAngleDown,
  faStar,
  faInfoCircle,
  faCaretRight,
  faCaretDown,
  faCaretUp,
  faMinus,
  faCrosshairs,
  faCog,
  faSyncAlt,
  faExpandArrowsAlt,
  faFilter,
  faFileDownload,
  faTrophy,
  faLock,
  faQuestionCircle,
  faSave,
  faChartBar,
  faSearchPlus,
  faRocket,
  faFileCsv,
  faMinusCircle,
  faPlusCircle,
  faWindowMaximize,
  faChevronCircleUp,
  faChevronCircleDown,
  faCompass,
  faChartPie,
  faChartLine,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faPlayCircle,
  faSortAmountDown,
  faCircle,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCheckCircle as faCheckCircleR,
  faCircle as faCircleR,
  faCompass as faCompassR,
  faCopy as faCopyR,
  faFileAlt as faFileAltR,
  faQuestionCircle as faQuestionCircleR,
  faSquare as faSquareR,
  faUser as faUserR,
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faEllipsisV,
  faEllipsisH,
  faBookOpen,
  faSortAmountDownAlt,
  faEye,
  faCopy,
  faCopyR,
  faInfinity,
  faArrowUp,
  faArrowDown,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faCircleR,
  faReceipt,
  faGift,
  faGamepad,
  faUserTie,
  faCreditCard,
  faHome,
  faTimes,
  faTable,
  faShareSquare,
  faEnvelope,
  faCode,
  faPaperPlane,
  faShare,
  faCloudDownloadAlt,
  faShareAlt,
  faCheckCircle,
  faCheckCircleR,
  faSearch,
  faExclamationCircle,
  faArrowAltCircleLeft,
  faUser,
  faUserR,
  faCheck,
  faBars,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faHistory,
  faTrashAlt,
  faCheckSquare,
  faSquare,
  faSquareR,
  faPencilAlt,
  faBug,
  faBomb,
  faArrowRight,
  faArrowLeft,
  faAngleDown,
  faStar,
  faInfoCircle,
  faCaretRight,
  faCaretDown,
  faCaretUp,
  faPlus,
  faMinus,
  faCrosshairs,
  faCog,
  faSyncAlt,
  faExpandArrowsAlt,
  faLink,
  faFilter,
  faFileDownload,
  faTrophy,
  faLock,
  faQuestionCircle,
  faQuestionCircleR,
  faSave,
  faChartBar,
  faSearchPlus,
  faRocket,
  faFileCsv,
  faMinusCircle,
  faPlusCircle,
  faWindowMaximize,
  faChevronCircleUp,
  faChevronCircleDown,
  faCompass,
  faCompassR,
  faFileAltR,
  faChartPie,
  faChartLine,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faPlayCircle,
  faSortAmountDown,
  faCircle,
);
